import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  cards:any = [
    {
      count: 12345,
      text: 'Registered Facilities',
      color: '#ED1556'
    },
    {
      count: 19876,
      text: 'Certified Facilities',
      color: '#ED1556'
    },
    {
      count: 8830,
      text: 'Trained Providers',
      color: '#ED1556'
    },
    {
      count: 12578,
      text: 'Facilities under quality improvement',
      color: '#ED1556'
    },
    {
      count: 18762,
      text: 'Mothers reached so far',
      color: '#ED1556'
    }
  ]
  
  loginStatus: boolean = false;
  constructor( private router: Router,) { 
  }
  
  ngOnInit(): void {
    this.loginStatus = sessionStorage.getItem("loginStatus") == 'true' ? true : false;
    console.log("loginStatus in dashnoard", this.loginStatus);
    
  }

  registerClick(){
    this.router.navigateByUrl('login/register')
  }

}
